import { css } from '@emotion/react';

/**
 * The light frosted "glass" fill shared by the service cards, the bottom bar
 * and the closed notice. Border and shadow are separate so shapes that don't
 * want a full border (the bottom bar) or a shadow can skip them.
 */
export const glassSurfaceCss = css`
  background: rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
`;

export const glassBorderCss = css`
  border: 1px solid rgba(255, 255, 255, 0.35);
`;

export const glassCardShadowCss = css`
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.35);
`;
